import CardWithThumbnails from '../../../../components/card-with-thumbnails/card-with-thumbnails';
import index, { noFeatureFlag as noFeatureFlagConnect } from './index';

const configuredCardWithThumbnails = index(CardWithThumbnails);
export default configuredCardWithThumbnails;
export const noFeatureFlag = noFeatureFlagConnect(CardWithThumbnails);
